import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { GlobalConstants } from '../constants/global-constants';

@Injectable()
export class BypassAuthInterceptorService implements HttpInterceptor {

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    const bypassToken = sessionStorage.getItem(GlobalConstants.bypassTokenStorageKey);

    if (bypassToken && !req.headers.has('Authorization')) {
      const modifiedReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${bypassToken}`
        }
      });
      return next.handle(modifiedReq);
    }

    return next.handle(req);
  }
}
